import React from 'react';
import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './customerio-init';

Sentry.init({
  dsn: 'https://e27fa11ac4bda2e38f9e6c15ee74f92e@o4509474690433025.ingest.us.sentry.io/4509474691350528',
  release: process.env.SENTRY_RELEASE,
  environment: process.env.NODE_ENV,
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ['localhost', /^https:\/\/.*\.getfoodfight\.link/],
});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />,
  </React.StrictMode>,
);
// Added a Comment for Practice Purposes

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
